import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';

import { partial } from '../../../utils/';

import * as actions from '../inspection.actions';
import { getAllAvailableTypesForList } from '../../inspectionType/inspectionType.selectors';

import Avatar from 'material-ui/Avatar';
import { ListItem, ListItemText } from 'material-ui/List';
import { PageAppBar } from '../../core/components/';
import { PinnedSubHeaderList } from '../../common/components/list';

const styles = theme => ({
  text: {
    color: theme.palette.primary[500],
    fontWeight: theme.typography.fontWeightMedium,
    fontSize: 15,
  },
  root: {
    backgroundColor: theme.palette.background.default,
  },
  content: {
    maxWidth: 1040,
  },
  image: {
    borderRadius: 0,
  }
});

class BrandTypeSelectList extends Component {
  componentDidMount = () => {
    const { readInspectionTypes } = this.props;
    readInspectionTypes();
  };

  onItemSelect = (brandId, typeId) => {
    const { history } = this.props;
    history.push(`/inspection/new/${brandId}/${typeId}`);
  };

  renderItem = (item, index) => {
    const { classes } = this.props;
    return (
      <ListItem
        button
        key={`item-${index}`}
        onClick={partial(this.onItemSelect, item.brandId, item.typeId)}
      >
        <Avatar src={item.imgSrc} className={classes.image} />
        <ListItemText
          primary={`${item.label}`}
          classes={{
            text: classes.text,
          }}
        />
      </ListItem>
    );
  };

  render() {
    const { backPath, inspectionTypes, classes } = this.props;
    return (
      <div className={classes.root}>
        <PageAppBar title="Uusi tarkastusraportti" backPath={backPath} />
        <PinnedSubHeaderList
          title="Valitse osasto"
          items={inspectionTypes}
          renderItem={this.renderItem}
          onItemSelect={this.onItemSelect}
          className={classes.content}
        />
      </div>
    );
  }
}

BrandTypeSelectList.propTypes = {
  backPath: PropTypes.string.isRequired,
  classes: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  inspectionTypes: PropTypes.array.isRequired,
  readInspectionTypes: PropTypes.func.isRequired,
};

const mapStateToProps = state => {
  const inspectionTypes = getAllAvailableTypesForList(state) || [];
  return {
    inspectionTypes,
  };
};

export default connect(mapStateToProps, Object.assign({}, actions))(
  withStyles(styles)(BrandTypeSelectList)
);



// WEBPACK FOOTER //
// ./src/modules/inspection/components/BrandTypeSelectList.js